<div class="h-screen grid grid-cols-1 md:grid-cols-[3fr_2fr]">
  <div class="flex flex-col justify-between p-8">
    <app-nav-button></app-nav-button>
    <header class="flex flex-col w-full items-center mt-14">
      <img src="assets/icon/codijobs.png" class="h-14" alt="" />
      <h1 class="text-3xl text-center font-bold text-gray-700">
        Bienvenido a <span class="text-primary">Codijobs</span>
      </h1>
      <p class="mt-2 text-lg text-gray-600">Inicia Sesión</p>
    </header>
    <section class="flex-1 mt-10">
      <form
        [formGroup]="loginForm"
        (ngSubmit)="onSubmit()"
        class="max-w-md mx-auto mt-5 space-y-5"
      >
        <app-input-text
          label="Correo electrónico"
          placeholder="correo@ejemplo.com"
          [control]="loginForm.get('email')"
        />
        <div></div>
        <app-input-text
          label="Contraseña"
          placeholder="Tu contraseña"
          type="password"
          [control]="loginForm.get('password')"
        />
        <a
          href="https://codideep.com/usuario/recuperarcontrasenia"
          target="_blank"
          rel="noopener noreferrer"
          class="text-sm text-primary hover:underline transition duration-150 ease-in-out"
        >
          ¿Olvidaste tu contraseña?
        </a>
        <div class="mb-10"></div>
        <app-loading-button
          [text]="'Iniciar sesión'"
          [loading]="loading"
          type="submit"
        >
        </app-loading-button>
      </form>
      <div class="mt-8 text-center">
        <p class="text-sm text-gray-600">
          ¿No tienes una cuenta?
          <a
            routerLink="/register"
            class="text-primary cursor-pointer font-medium hover:underline transition duration-150 ease-in-out"
          >
            Regístrate aquí
          </a>
        </p>
      </div>
    </section>
  </div>
  <div class="hidden md:block relative bg-[#D0D9FF]">
    <img
      src="assets/img/abs1.jpg"
      alt="Imagen decorativa"
      class="w-full h-full object-cover absolute"
    />
  </div>
</div>
